<article
  class="be-page-section"
  aria-labelledby="appStoreHeading"
  aria-describedby="appStoreBody"
>
  <span class="be-eyebrow-text new-tag mb-4">NEW</span>
  <h3 class="app-card-title mb-4" id="appStoreHeading">
    Download the Best Egg mobile app
  </h3>
  <p class="app-card-text mb-4" id="appStoreBody">
    Easily and securely manage your Best Egg loan accounts on-the-go.
  </p>
  <app-app-store-links></app-app-store-links>
</article>
